// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"970ef698","396":"f689c534","453":"c3cfd945","455":"e489a0eb","977":"03e50727"}[chunkId] + ".chunk.js";
};